import { BrandAndMarketListItem } from '../../../integrated-client/models';
import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  showDeleted: boolean
  showDisabled: boolean
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  total: number
  currentPage: number
}

export class RemarksFormData implements IFormData {
  showDeleted: boolean
  showDisabled: boolean
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  total: number
  currentPage: number

  constructor() {
    this.showDeleted = false;
    this.showDisabled = false;
    this.brandAndMarket = null;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
